import React, { useState } from 'react';
import Text from '../../../../Components/Base/Text/Text';
import MagicForm from '../../../../Components/Form/MagicForm';
import FullPageLoading from '../../../../Components/Utils/FullPageLoading/FullPageLoading';
import { useEffectAsync } from '../../../../helpers';
import { useHealthPlanContext } from '../../../../Services/HealthPlanContext';
import useHealthPlanMonitoringForm from '../../Hooks/useHealthPlanMonitoringForm';

interface HealthPlanMonitoringProps {
	onSuccess?: any;
}

const HealthPlanMonitoring: React.FC<HealthPlanMonitoringProps> = ({
	onSuccess,
}) => {
	const [isInitialized, setIsInitialized] = useState(false);
	const { activeHealthPlanUserItem } = useHealthPlanContext();
	const [defaultData, setDefaultData] = useState(null);
	const { formScheme, submitValues } = useHealthPlanMonitoringForm(
		activeHealthPlanUserItem?.extra.month,
	);

	useEffectAsync(async () => {
		setDefaultData(activeHealthPlanUserItem?.extra?.data ?? null);
		setIsInitialized(true);
	});

	if (!isInitialized) {
		return <FullPageLoading />;
	}

	return (
		isInitialized && (
			<>
				<Text
					className='danger-text mb-4'
					tx={'diabetes.healthPlanDefaultChange'}
				/>
				<MagicForm
					formScheme={formScheme}
					defaultValues={defaultData}
					onSubmit={values => submitValues?.(values, onSuccess)}
				/>
			</>
		)
	);
};

export default HealthPlanMonitoring;
